//@flow
import ModalStoreClass from './modalStoreClass';

export default new ModalStoreClass();
